import { memo } from 'react';
import spellcasterDown from './goblin-spellcaster/goblin-spellcaster-down.png';
import spellcasterUp   from './goblin-spellcaster/goblin-spellcaster-up.png';

// Only two directional assets exist: up and down.
// Left/right movement maps to whichever vertical axis is dominant; if the
// enemy is mostly horizontal, default to 'down' (facing toward a level player).
const DIR_MAP = {
  up:   spellcasterUp,
  down: spellcasterDown,
};

const DIRS = Object.keys(DIR_MAP);

/**
 * Convert (dx, dy) → 'up' | 'down'.
 * dx/dy = vector from enemy centre → player centre.
 */
function toDir(dx, dy) {
  // Prioritise vertical component; fall back to down for pure horizontals
  return dy < 0 ? 'up' : 'down';
}

/**
 * Directional goblin-spellcaster PNG sprite.
 *
 * Both directional images are always present in the SVG so the browser
 * fetches them both on first mount. Direction changes only toggle visibility —
 * no href mutation, no extra network requests.
 *
 * Props:
 *   dx / dy — vector enemy-centre → player-centre (for facing direction)
 *   size    — rendered width & height in px
 */
export const GoblinSpellcasterSprite = memo(function GoblinSpellcasterSprite({ dx, dy, size }) {
  const dir = toDir(dx, dy);
  return (
    <svg width={size} height={size} style={{ display: 'block' }}>
      {DIRS.map(d => (
        <image
          key={d}
          href={DIR_MAP[d]}
          x={0} y={0}
          width={size} height={size}
          preserveAspectRatio="xMidYMid meet"
          style={{ display: d === dir ? undefined : 'none' }}
        />
      ))}
    </svg>
  );
});
